import React from 'react';
import {connect} from 'react-redux';
import Config from 'app/Config';
import PackageDataAndCollectiveUsage from './PackageDataAndCollectiveUsage/PackageDataAndCollectiveUsage';
import FamilyMemberPackageUsage from './FamilyMembersPackageUsages/FamilyMemberPackageUsage/FamilyMemberPackageUsage';
import HorizontalSeparator from './HorizontalSeparator/HorizontalSeparator';
import {imagesByCode, usedMetricsByCode, collectiveUsageByCode} from '../../utils/constants';

const toInt = (value) => Math.floor(parseFloat(value));

const PackageInfo = ({packageData, collectiveUsage, isLastElement, subscriberNameMap}) => {
  const packages = packageData || [];

  return (
    <div className='family-package-usage-info-container'>
      <PackageDataAndCollectiveUsage
        packageType={collectiveUsageByCode[collectiveUsage?.measur_code]}
        packageCapacity={`${toInt(collectiveUsage?.pk_allowed)}${usedMetricsByCode[collectiveUsage?.measur_code]}`}
        collectiveUsage={`${toInt(collectiveUsage?.used_pct)}%`}
      />

      {packages?.length > 0 && (
        <div className='family-members-usage-list'>
          {packages?.map((packageDetails, index) => (
            <FamilyMemberPackageUsage
              key={index}
              serviceIcon={imagesByCode[packageDetails?.measur_code]}
              mobile={packageDetails?.subscriber_no}
              name={subscriberNameMap[packageDetails?.subscriber_no]}
              usage={`${toInt(packageDetails?.mps_used)}${usedMetricsByCode[packageDetails?.measur_code]}`}
            />
          ))}
        </div>
      )}
      {!isLastElement && (
        <div className='separators-container'>
          <HorizontalSeparator />
        </div>
      )}
    </div>
  );
};
const mapStateToProps = (state) => ({
  subscriberNameMap: state.cellcomAbroad.familyPackageUsageDetails.subscriberNameMap,
});

const mapDispatchToProps = {

};
export default connect(mapStateToProps, mapDispatchToProps)(PackageInfo);
